// Actions
import { SET_NEW_LIST } from "../actionTypes/attributes.actionTypes";

export interface ISetNewListAction {
  type: string;
  payload: boolean;
}

export function setNewList(newList: boolean): ISetNewListAction {
  return { type: SET_NEW_LIST, payload: newList };
}
try {
    // @ts-ignore
    setNewList.displayName = "setNewList";
    // @ts-ignore
    setNewList.__docgenInfo = { "description": "", "displayName": "setNewList", "props": { "valueOf": { "defaultValue": null, "description": "Returns the primitive value of the specified object.", "name": "valueOf", "required": false, "type": { "name": "() => boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/Attributes/actionCreators/attributes.actionCreators.ts#setNewList"] = { docgenInfo: setNewList.__docgenInfo, name: "setNewList", path: "src/shared/containers/Attributes/actionCreators/attributes.actionCreators.ts#setNewList" };
}
catch (__react_docgen_typescript_loader_error) { }